var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.069 12a2.09 2.09 0 0 1-1.464-.554C.202 11.076 0 10.629 0 10.104V1.896C0 1.37.202.924.605.554A2.09 2.09 0 0 1 2.069 0h3.4c1.033 0 1.97.292 2.813.876.842.583 1.263 1.375 1.263 2.374 0 .669-.165 1.206-.495 1.613-.33.407-.675.702-1.032.885v.015c.447.176.89.49 1.327.94.437.45.655 1.07.655 1.864 0 1.203-.487 2.076-1.461 2.619-.975.543-1.94.814-2.899.814H2.07zm.866-2.423h2.5c.655 0 1.08-.16 1.276-.478.195-.319.293-.58.293-.787 0-.206-.098-.469-.293-.79-.196-.32-.638-.48-1.328-.48H2.935v2.535zm0-4.88h2.261c.471 0 .827-.116 1.067-.35.24-.235.36-.503.36-.805 0-.333-.132-.607-.395-.82-.263-.213-.595-.32-.997-.32H2.935v2.296z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.ef7832f39ee0aaf6e09b0832bb9f68ab.svg";
export { ForwardRef as ReactComponent };